/**
 * auth-layout.tsx — Shell for /auth/* routes (iltizam Phase 6).
 *
 * Same warm-cream gradient as the app shell, top bar with the wireframe
 * logo (ink square + yellow inset), and a centered max-width column
 * for the auth card. Replaces the legacy slate-50 chrome.
 */

import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from '@/components/language-toggle';

export function AuthLayout(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="min-h-dvh bg-iltizam-app">
      <header className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-6 py-5">
        <Link to="/" className="flex items-center gap-2.5">
          <span
            aria-hidden="true"
            className="flex h-9 w-9 items-center justify-center rounded-xl bg-iltizam-ink"
          >
            <span className="h-4 w-4 rounded-[5px] bg-iltizam-yellow" />
          </span>
          <span className="text-[21px] font-extrabold tracking-[0.5px] text-iltizam-ink">
            {t('brand.name')}
          </span>
        </Link>
        <LanguageToggle />
      </header>
      <main className="flex min-h-[calc(100dvh-90px)] items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
